import { useNavigate } from 'react-router-dom';
import ReactEDSWrapper from '../utils/react-eds-wrapper';
import { Breadcrumb } from '@dsi/react-eds';

export const UseBreadcrumb = (dataArray: { title: string; url: string }[]) => {
  const navigate = useNavigate();
  return (
    <ReactEDSWrapper
      component={Breadcrumb}
      data={dataArray.map((d) => {
        return { title: d.title, action: d.url ? () => navigate(d.url) : () => {} };
      })}
      data-testid="breadcrumb"
    />
  );
};
